import Vue from "vue";
import VueI18n from "vue-i18n";
import az from "../locales/az.json";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "az",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "az",
  messages: { az },
});
